<app-userapi-shared-non-oauth [userApi]="userApi">

  <div class="flex space-x-2 mb-1">
    @if (userApi.api.urlPrefix) {
      <div class="my-auto">{{ userApi.api.urlPrefix }}</div>
    }
    <div class="w-full">
      <FloatingLabelInput
          id="url"
          class="form-label"
          [label]="'INCLUDE_MODALUSERAPI_LABEL_URL' | translate: { api: userApi.api.name }"
          [appColor]="appColor()"
          [(myValue)]="userApi.url"
          (myValueChange)="userApi.configured = !!userApi.url && !!userApi.publicKey && !!userApi.privateKey">
      </FloatingLabelInput>
    </div>
    @if (userApi.api.urlPostfix) {
      <div class="my-auto">{{ userApi.api.urlPostfix }}</div>
    }
  </div>

  <p [innerHTML]="userApi.api.configDescription"></p>

  <FloatingLabelInput
      id="publicKey"
      class="form-label"
      label="API Key"
      [appColor]="appColor()"
      [(myValue)]="userApi.publicKey"
      (myValueChange)="userApi.configured = !!userApi.url && !!userApi.publicKey && !!userApi.privateKey">
  </FloatingLabelInput>

  <FloatingLabelInput
      id="privateKey"
      class="form-label"
      label="API Secret"
      [appColor]="appColor()"
      [(myValue)]="userApi.privateKey"
      (myValueChange)="userApi.configured = !!userApi.url && !!userApi.publicKey && !!userApi.privateKey">
  </FloatingLabelInput>

</app-userapi-shared-non-oauth>
